import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <section className="py-32 bg-lovac min-h-[60vh] flex items-center">
      <Seo
        title="Pagina non trovata · 404 | Lovac"
        description="La pagina richiesta non esiste o è stata spostata."
        path={pathname}
        noindex
      />
      <div className="container-narrow text-center">
        <p className="font-mono text-sm text-lovac-muted">404</p>
        <h1 className="font-display text-5xl sm:text-6xl mt-4 text-lovac-dark leading-tight">
          Pagina non trovata.
        </h1>
        <p className="text-lovac-muted mt-6 max-w-xl mx-auto">
          La pagina che cerchi non esiste o è stata spostata. Torna alla home o esplora il sito.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-10">
          <Link to="/" className="btn-primary">Torna alla home <ArrowRight size={16} /></Link>
          <Link to="/casi-studio" className="btn-outline">Guarda i casi studio <ArrowRight size={16} /></Link>
        </div>
      </div>
    </section>
  );
}
